/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading dependencies
 * -----------------------------------------------------------------------------------------------------------
 */
import Vue from 'vue'
import Router from 'vue-router'
import { concat } from 'lodash'
import Meta from 'vue-meta'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading module routes
 * -----------------------------------------------------------------------------------------------------------
 */
import accountRoutes from '../components/account/routes'
import dashboardRoutes from '../components/dashboard/routes'
import invoiceRoutes from '../components/invoice/routes'
import receiptRoutes from '../components/receipt/routes'
import userRoutes from '../components/user/routes'
import roleRoutes from '../components/role/routes'
import permissionRoutes from '../components/permission/routes'
import compareRoutes from '../components/compare/routes'
import salerRoutes from '../components/saler/routes'
import permissionDeniedRoutes from 'components/permissiondenied/routes'
import affiliateRoutes from 'components/affiliate/routes'
import salerConfigRoutes from 'components/salerConfig/routes'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }), // Chuyen trang thi scroll ve top
  routes: concat(
    accountRoutes,
    dashboardRoutes,
    invoiceRoutes,
    userRoutes,
    roleRoutes,
    receiptRoutes,
    permissionRoutes,
    compareRoutes,
    permissionDeniedRoutes,
    salerRoutes,
    affiliateRoutes,
    salerConfigRoutes
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js